import { declareString } from "@1js/localization";

export const TeamIconTooltip = declareString("promptLibrary.teamIconTooltip", {
  text: "Shared to Team",
  comment:
    "Tooltip that's displayed to user when user hovers over the team icon on a Copilot prompt card",
});

export const AgentIconTooltip = declareString(
  "promptLibrary.agentIconTooltip",
  {
    text: "Agent",
    comment:
      "Tooltip that's displayed to user when user hovers over the agent icon on a Copilot prompt card",
  }
);
